import React from "react";
import Typable from "shared/components/oknf/_Typable";

const OkInput = React.forwardRef((props, ref) => (
	<Typable ref={ref} type="text" {...props} />
));

export default OkInput;



// WEBPACK FOOTER //
// ./src/shared/components/oknf/OkInput.jsx